import { render, staticRenderFns } from "./ProductTemplateForm.vue?vue&type=template&id=e5bc787a"
import script from "./ProductTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProductTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplateForm.vue?vue&type=style&index=0&id=e5bc787a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports